import { SimpleEntityGrid } from "../../components/grid/SimpleEntityGrid";
import { UpsertOrderFormContainer } from "../../containers";
import { OrderTransport } from "../../transports/order";
import { UpsertOrderDTOSchema } from "../../types/orders/order";
import { useIntl } from "react-intl";
import useTitleIAGridColumns from "./useTitleIAGridColumns";
import useTitleIAGridActions from "./useTitleIAGridActions";
import useTitleIAGridToolbarButtons from "./useTitleIAToolbarButtons";
import { PageTitle } from "src/_metronic/layout/core";

const TitleIA = () => {
    const { formatMessage } = useIntl();
    const actions = useTitleIAGridActions();

    const gridColumns = useTitleIAGridColumns();

    const toolActionsButton = useTitleIAGridToolbarButtons();

    return (
        <>
            <PageTitle>{formatMessage({ id: "titleIA.title" })}</PageTitle>
            <SimpleEntityGrid
                columns={gridColumns}
                actions={actions}
                toolbarButtonAction={toolActionsButton}
                saveHandler={OrderTransport.save}
                entityName={formatMessage({ id: "common.entity.titleIA" })}
                validationSchema={UpsertOrderDTOSchema}
                toggleActiveHandler={OrderTransport.toggleActive}
                formTransformer={OrderTransport.formTransformer}
                listHandler={OrderTransport.titleIAList}
                formBody={UpsertOrderFormContainer}
            />
        </>
    );
};

export default TitleIA;
